//import { generateGeoLocationJson } from './marketplaceData.duck';

import { subscribeToNewsletter } from '../util/api';
import { logError } from '../util/log';

const authenticated = (authInfo) => authInfo && authInfo.isAnonymous === false;

// ================ Action types ================ //

export const OPEN_NEWSLETTER_SUBSCRIBE_MODAL_REQUEST =
  'app/newsletter/OPEN_NEWSLETTER_SUBSCRIBE_MODAL_REQUEST';
export const CLOSE_NEWSLETTER_SUBSCRIBE_MODAL_REQUEST =
  'app/newsletter/CLOSE_NEWSLETTER_SUBSCRIBE_MODAL_REQUEST';
export const NEWSLETTER_SUBSCRIBE_REQUEST = 'app/newsletter/NEWSLETTER_SUBSCRIBE_REQUEST';
export const NEWSLETTER_SUBSCRIBE_SUCCESS = 'app/newsletter/NEWSLETTER_SUBSCRIBE_SUCCESS';
export const NEWSLETTER_SUBSCRIBE_ERROR = 'app/newsletter/NEWSLETTER_SUBSCRIBE_ERROR';

export const OPEN_NEWSLETTER_MODAL_REQUEST = 'app/newsletter/OPEN_NEWSLETTER_MODAL_REQUEST';
export const CLOSE_NEWSLETTER_MODAL_REQUEST = 'app/newsletter/CLOSE_NEWSLETTER_MODAL_REQUEST';

// ================ Reducer ================ //

/** @type {import('../../types/vansite').VanSite.State.Newsletter} */
const initialState = {
  newsletterSubscribeInProgress: false,
  newsletterSubscribeError: null,
  newsletterModalOpen: false,
  newsletterSubscribeModalOpen: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case NEWSLETTER_SUBSCRIBE_REQUEST:
      return { ...state, newsletterSubscribeInProgress: true, newsletterSubscribeError: null };
    case NEWSLETTER_SUBSCRIBE_SUCCESS:
      return { ...state, newsletterSubscribeInProgress: false };
    case NEWSLETTER_SUBSCRIBE_ERROR:
      return { ...state, newsletterSubscribeInProgress: false, newsletterSubscribeError: payload };

    case OPEN_NEWSLETTER_SUBSCRIBE_MODAL_REQUEST:
      return { ...state, newsletterSubscribeModalOpen: true };
    case CLOSE_NEWSLETTER_SUBSCRIBE_MODAL_REQUEST:
      return { ...state, newsletterSubscribeModalOpen: false };

    case OPEN_NEWSLETTER_MODAL_REQUEST:
      return { ...state, newsletterModalOpen: true };
    case CLOSE_NEWSLETTER_MODAL_REQUEST:
      return { ...state, newsletterModalOpen: false };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const openNewsletterSubscribeModal = () => ({
  type: OPEN_NEWSLETTER_SUBSCRIBE_MODAL_REQUEST,
});

export const closeNewsletterSubscribeModal = () => ({
  type: CLOSE_NEWSLETTER_SUBSCRIBE_MODAL_REQUEST,
});

export const newsletterSubscribeRequest = () => ({
  type: NEWSLETTER_SUBSCRIBE_REQUEST,
});

export const newsletterSubscribeSuccess = () => ({
  type: NEWSLETTER_SUBSCRIBE_SUCCESS,
});

export const newsletterSubscribeError = (error) => ({
  type: NEWSLETTER_SUBSCRIBE_ERROR,
  payload: error,
  error: true,
});

export const openNewsletterModal = () => ({
  type: OPEN_NEWSLETTER_MODAL_REQUEST,
});

export const closeNewsletterModal = () => ({
  type: CLOSE_NEWSLETTER_MODAL_REQUEST,
});

// ================ Thunks ================ //

export const newsletterSubscribe = (values) => async (dispatch, getState, sdk) => {
  const { firstName, email } = values;

  dispatch(newsletterSubscribeRequest());
  try {
    const response = await subscribeToNewsletter({ firstName, email });
    dispatch(newsletterSubscribeSuccess());
    return response;
  } catch (e) {
    logError(e, 'newsletter-subscribe', {
      firstName,
      email,
    });
    dispatch(newsletterSubscribeError(e));
    throw e;
  }
};
